import { render, staticRenderFns } from "./or_fp_report.vue?vue&type=template&id=6fab798a&scoped=true"
import script from "./or_fp_report.vue?vue&type=script&lang=js"
export * from "./or_fp_report.vue?vue&type=script&lang=js"
import style0 from "./or_fp_report.vue?vue&type=style&index=0&id=6fab798a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fab798a",
  null
  
)

export default component.exports